import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRolesContext } from '../context/RolesContext';
import { useUserContext } from '../context/UserContext';
import { useEffect } from 'react';
import { useStatusContext } from '../context/StatusContext';

const ModalCreatetRole = ({ onClose, object }) => {
  const { roleId } = useUserContext();
   const [roleType, setRoleType] = useState(null)
   const {status} = useStatusContext();
  const { addRoles, editRoles, deleteRole, roles } = useRolesContext();
  const [name, setName] = useState(object?object.name:'');
  const [ruName, setRuName] = useState(object?object.ruName:'');
  const [type, setType] = useState(object?object.type:"admin");
  const [columns, setColumns] = useState({})
  
  let col = status.map((st)=>{return{id:st._id, label:st.name}})
  useEffect(()=>{
      if (roles){
        let idx = roles.findIndex((r)=>{return r._id===roleId});
        if (idx !== -1){
          setRoleType(roles[idx].type)
        }
      }
    }, [roles])

    useEffect(()=>{
      let st = {};
      if (object && object.columns){
        status.map((stat)=>{
          if (object.columns[stat._id]) {
            st[stat._id] = true
          } else {
            st[stat._id] = false
          }
        })
      } else{
        status.map((stat)=>{st[stat._id]=true })
      }
      setColumns(st)
    }, [status])

    const handleChange = (event) => {
    setColumns({
      ...columns,
      [event.target.name]: event.target.checked,
    });
  };

  // Обработчик сохранения комментария
  const handleSave = () => {
    if (object) {
        editRoles(({name, ruName, type, columns}), object._id)
    } else {
        addRoles({name, ruName, type, columns })
    }
      onClose();
  };
  const handleDelete = () => {
    deleteRole(object._id);
    onClose();
  }
  // Обработчик закрытия окна
  const handleClose = () => {
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="task-modal admin-modal">
        <header className="task-modal__header">
          <h2 className="task-modal__title">
            {!object ? 'Создание роли' : 'Редактирование роли'}
          </h2>
          <button className="task-modal__close" onClick={handleClose}>×</button>
        </header>

        <div className="task-modal__body">
          <div className="admin-modal__grid">
            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="name">Название (латиницей)</label>
              <input
                className="admin-modal__input"
                id="name"
                required
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="ruName">Русское название</label>
              <input
                className="admin-modal__input"
                id="ruName"
                required
                value={ruName}
                onChange={e => setRuName(e.target.value)}
              />
            </div>
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label" htmlFor="type">Тип роли</label>
              <select
                className="admin-modal__select"
                id="type"
                value={type}
                onChange={e => setType(e.target.value)}
              >
                <option value="admin">Администратор</option>
                <option value="worker">Менеджер</option>
                <option value="accountant">Бухгалтер</option>
                <option value="storekeeper">Кладовщик</option>
              </select>
            </div>
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label">Видимые колонки</label>
              <div className="admin-modal__checkboxes">
                {col.map(item => (
                  <label key={item.id} className="admin-modal__checkbox-label">
                    <input
                      type="checkbox"
                      name={item.id}
                      checked={!!columns[item.id]}
                      onChange={handleChange}
                      className="admin-modal__checkbox"
                    />
                    {item.label}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <footer className="task-modal__footer">
          <button className="task-modal__btn task-modal__btn--ghost" onClick={handleClose}>Отмена</button>
          <button className="task-modal__btn task-modal__btn--primary" onClick={handleSave}>Сохранить</button>
          {(roleType === 'firstAdmin' || roleType === 'admin') && object && (
            <button className="task-modal__btn task-modal__btn--danger" onClick={handleDelete}>Удалить</button>
          )}
        </footer>
      </div>
    </div>
  );
};

// Пропсы, обязательные для корректной работы
ModalCreatetRole.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ModalCreatetRole;